<header class="app-header portal-header navbar navbar-expand-lg navbar-light pe-sm-4 pe-2">
  <!-- Responsive sidebar toggle -->
  <button class="navbar-toggler sidebar-toggler" (click)="toggleSidebar()" type="button">
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Logo -->
  <a class="navbar-brand" routerLink="/"></a>

  <!-- Navbar on the right -->
  @if (user$ | async; as user) {
    <ul class="nav navbar-nav ms-auto">
      <!-- Search -->
      @if (authUserIsEndUser === false) {
        <li class="nav-item me-2">
          <portal-search-input></portal-search-input>
        </li>
      }
      <!-- Language -->
      @if (enableTranslator) {
        <li class="d-none d-lg-flex nav-item">
          <ng-container [ngTemplateOutlet]="languageTemplate"></ng-container>
        </li>
      }
      <!-- My notifications -->
      <portal-my-notifications-dropdown
        class="nav-item ms-1"
        *portalIsAuthorized="{
          requiredUserLevel: UserLevel.EnterpriseAdmin,
        }"
        role="listitem"
      ></portal-my-notifications-dropdown>
      <!-- Rich presence -->
      @if (richPresenceActive) {
        <li class="nav-item dropdown ms-1">
          <portal-rich-presence-state dropdownPlacement="bottom-end"></portal-rich-presence-state>
        </li>
      }
      <!-- User -->
      <li class="nav-item dropdown">
        <a
          class="nav-link g-cursor-pointer dropdown-toggle"
          [delay]="0"
          [popover]="true"
          [portalTippy]="userContent"
          aria-expanded="false"
          aria-haspopup="true"
          role="button"
          trigger="click"
        >
          <i class="far fa-user fa-fw"></i>
          <span class="d-none d-sm-inline">
            {{ user.username }}
          </span>
          <small class="d-none d-sm-inline text-muted portal-header__account-type">
            {{ 'role.' + SecurityRoleLevelToRoleMapping[user.role.level] | translate }}
          </small>
        </a>
        <ng-template #userContent>
          <div class="g-min-width-200px">
            <portal-link
              *portalUserIsEndUser
              classes="dropdown-item"
              portalDropdownItem
              route="end-user-personalization"
            >
              <i class="far fa-user"></i>
              {{ 'header.userDropdown.endUser' | translate }}
            </portal-link>
            <portal-link
              *portalUserIsEnterprise
              classes="dropdown-item"
              portalDropdownItem
              route="enterprise-settings-customer"
            >
              <i class="far fa-wrench"></i>
              {{ 'header.userDropdown.enterprise' | translate }}
            </portal-link>
            @if (languages.length > 1) {
              <div class="dropdown-header text-center">
                {{ 'portal.language' | translate }}
              </div>
              @for (language of languages; track language) {
                <button
                  class="portal-header__language-item"
                  [ngClass]="{ 'portal-header__language-item--selected': activeLanguage === language }"
                  (click)="switchLanguage(language)"
                  portalDropdownItem
                >
                  <span class="flex-grow-1">{{ 'language.' + language | portalTranslate }}</span>
                  @if (activeLanguage === language) {
                    <i class="far fa-check"></i>
                  }
                </button>
              }
            }
            <!-- Target System Switcher -->
            <portal-backend-system-switcher></portal-backend-system-switcher>
            <!-- @if (userAccountURL != null) {
            <a href="{{ userAccountURL }}" class="dropdown-item">User Account</a>
            } -->
            <button class="portal-header__logout" (click)="logout()" portalDropdownItem>
              <i class="far fa-lock me-1"></i>
              {{ 'logout.button' | translate }}
            </button>
          </div>
        </ng-template>
      </li>
      <ng-template #languageTemplate>
        <!-- Language -->
        <li class="portal-header__language dropdown">
          <portal-icon-button
            class="dropdown-toggle"
            #tippy="tippy"
            [popover]="true"
            [portalTippy]="languageContent"
            iconClass="far fa-language fa-fw me-1"
            trigger="click"
          >
          </portal-icon-button>
          <ng-template #languageContent>
            <div>
              <!-- Translator -->
              <div class="dropdown-header text-center">
                {{ 'dev.translator.title' | translate }}
              </div>
              <a class="dropdown-item g-cursor-pointer" (click)="loadTranslator()" portalDropdownItem>
                {{ 'dev.translator.toggle' | translate }}
              </a>
              <a
                class="dropdown-item g-cursor-pointer"
                (click)="openTranslationOverview()"
                portalDropdownItem
              >
                {{ 'dev.translator.open.overview' | translate }}
              </a>
            </div>
          </ng-template>
        </li>
      </ng-template>
    </ul>
  }
</header>
